import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RFQHome from "./components/RFQ/RFQHome";
import AdditionalInformation from "./components/AdditionalInformation/AdditionalInformation";
//import QuoteDetails, { loader as quoteDetailLoader } from "./components/QuoteDetails/QuoteDetails";
import QuoteSubmitConfirmation from "./components/Confirmation/QuoteSubmitConfirmation";
//import { action as itemChangeAction } from "./components/Items/ItemList";
import QuoteContextProvider from "./store/QuoteContextProvider";
import { ApolloProvider } from "@apollo/client";
import withApollo from "./apollo/withApollo";
import QuoteHistorySelector from "./components/History/QuoteHistorySelector";
import QuoteDetailsSelector from "./components/QuoteDetails/QuoteDetailsSelector";
import RFQHomeSelector from "./components/RFQ/RFQHomeSelector";
  
const App = ({ apolloClient}) => {

  const routes = [
    {
      path: "/",
      children: [
        { index: true, element: <RFQHomeSelector />},
        { path: ":webRef", element: <RFQHomeSelector /> },
      ],
    },
    { path: "/additional-info", element: <AdditionalInformation /> },
    { path: "/confirmation", element: <QuoteSubmitConfirmation /> },
    {
      path: "/quotes",
      children: [
        { index: true, element: <QuoteHistorySelector/>},
        {
          path: ":webRef",
          element:  <QuoteDetailsSelector/>,
          //loader: quoteDetailLoader,
        },
      ],
    },
  ];
  
  const router = createBrowserRouter(routes, { basename: "/quote-app" });

  return (
    <ApolloProvider client={apolloClient}>
      <QuoteContextProvider>
        <RouterProvider router={router} />
      </QuoteContextProvider>
    </ApolloProvider>
  );
};
 
export default withApollo(App);